webpackJsonp([172886164755822],{

/***/ 752:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 867:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactAccessibleAccordion = __webpack_require__(38);
	
	__webpack_require__(752);
	
	var _reactYoutube = __webpack_require__(28);
	
	var _reactYoutube2 = _interopRequireDefault(_reactYoutube);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BGvideoOptions = {
	    height: '500',
	    width: '100%',
	    playerVars: { // https://developers.google.com/youtube/player_parameters
	        autoplay: 1,
	        controls: 0,
	        rel: 0,
	        showinfo: 0,
	        modestbranding: 1, // Hide the Youtube Logo
	        loop: 1, // Run the video in a loop - DOESN'T WORK - used onEnd function
	        fs: 0, // Hide the full screen button
	        cc_load_policy: 0, // Hide closed captions
	        iv_load_policy: 3, // Hide the Video Annotations
	        autohide: 0,
	        enablejsapi: 0
	    }
	};
	
	var SponsorChallenges = function SponsorChallenges(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'Sponsor Challenges :: DeltaHacks 5'
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'The DeltaHacks Sponsor Challenges' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { id: 'main', className: 'sponbg' },
	            _react2.default.createElement(
	                _reactAccessibleAccordion.Accordion,
	                null,
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Sponsor Challenges'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'box' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'What are the Sponsor Challenges?'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Each of the following challenges comes with their own prize category. For details on the prizes available, check out the event ',
	                        _react2.default.createElement(
	                            'u',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: '/devpost' },
	                                'DevPost'
	                            )
	                        ),
	                        '!',
	                        _react2.default.createElement('br', null)
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactAccessibleAccordion.AccordionItem,
	                    null,
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemTitle,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '+ Innovation Factory - Autonomous Solutions Challenge'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'Problem Statement:'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Cargo theft is a growing problem for Canadian businesses and their transportation providers. According to statistics from the Insurance Bureau of Canada\u2019s National Cargo Theft Reporting Program, 2018 will see record cargo thefts. They estimate that over $55 million in goods will be stolen this year. Most of the cargo theft is orchestrated by organized crime rings in Toronto, Montreal, and Vancouver.'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'In addition to the loss of the value of the goods stolen, businesses also suffer secondary financial losses due to increased insurance costs, increased security costs, increased technology costs to track assets, and loss of productivity when trucks are stolen and unavailable for use. There is also a safety issue for drivers when a cargo theft happens with a \u201Clive\u201D load on the road.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'Potential Solution:'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'While most medium- to large-scale trucking companies have tractors and trailers equipped with GPS tracking devices, these are often only useful in recovering the stolen tractor/trailer/goods well after the theft has taken place and been reported.'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'However, an opportunity exists to create a \u201Ctheft detection\u201D app that will provide a real time alert to company management that a theft may be in progress in its early stages. Using artificial intelligence, the app could identify if a tractor or trailer equipped with GPS is in motion during a time period that is outside the norm, based on historical GPS data. For example, most thefts take place on weekends. The app would detect if a trailer that typically works on Mondays to Fridays is in motion on a Saturday, and then alert management that there may be a theft in progress.'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'This app would benefit businesses by giving them precious time to alert police, which would increase the chances of recovering the goods, minimize possible damage to the equipment, and increase the chances of apprehending the thieves. As cargo theft arrests increase, the number of incidents will decrease as organized crime moves on to easier theft opportunities. Insurance premiums would decrease for companies as their security profile improves.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'Potential Customers:'
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Trucking and logistics companies'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Companies with their own fleet of trucks'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Insurance companies'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Alarm and security companies'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactAccessibleAccordion.AccordionItem,
	                    null,
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemTitle,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '+ McMaster Materials Department - The Ultimate Image Analysis Software'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'The properties of materials depend on the way in which atoms and defects are arranged in the material.  For this reason, materials engineers observe the material using optical and electron microscopes.  The images they take are often like attached figures.  What we would like you to do, is to measure the fractions of the light and dark \u201Cphases\u201D in these figures.  The fraction could simply be expressed as number of pixels of a given color over the total number of pixels. The problem is complicated by the lighting conditions.  Sometimes you\u2019ll get very good contrast between the phases (e.g. micro1.png) and sometimes there is less contrast.  In addition, the light and dark phases may contain \u201Cparticles\u201D like those shown in micro2.png.  You will be awarded (25) points for achieving each of the targets listed below as well as (50) points for the user interface and ease of use.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Target 1:  Measure the fraction of the dark phase with an accuracy of 0.5% or better in an image that does not contain particles (e.g. micro1.png).'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Target 2:  Measure the fraction of the dark phase with an accuracy of 0.5% or better in an image that contains particles (e.g. micro3.png).  For images with particles, the particles inside the dark phase should be counted with the dark phase and the ones inside the light phase should be counted with the light phase.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Target 3:  Same as target 2, but you will be given images with uneven lighting conditions.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Target 4:  You need to measure the average size (equivalent diameter) of the grains in the images.  The \u201Cgrains\u201D simply refer to the polygons that make the images.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Target 5:  You are able to produce a histogram of the grain size.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Materials for the challenge:',
	                            _react2.default.createElement(
	                                'code',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://www.dropbox.com/sh/w9ao0zobloqwjvf/AAAcE0Rf_SvSic_KWxFrBCX6a?dl=0' },
	                                    'Dropbox Link'
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactAccessibleAccordion.AccordionItem,
	                    null,
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemTitle,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '+ RBC - Made From Scratch'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Forget prepackaged products, the core parts of the winning project here will be fundamentally built from scratch. Libraries and frameworks are allowed and even encouraged, but the part of the project that makes it awesome should be written or built by you. ',
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement('br', null),
	                            'Open source libraries, tools, and frameworks can surely be puzzle pieces, but they cannot be the core or \u2018special sauce\u2019 of the solution.',
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement('br', null),
	                            'For example, you can\u2019t use the IMDB API for movie recommendations. You can however, use Google geolocation API\u2019s to help use maps to connect people\u2019s phones to a bank\u2019s branch, floodzones, etc. \u2013 since you\u2019re layering your own logic/analytics on top of some base datasets. ',
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement('br', null),
	                            'We do not want anyone reinventing the wheel, rather helping \u2018drive\u2019 change using one!'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactAccessibleAccordion.AccordionItem,
	                    null,
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemTitle,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '+ The Forge Outstanding Technology Award'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Awarded to two teams with the most commercial potential.'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactAccessibleAccordion.AccordionItem,
	                    null,
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemTitle,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '+ CIBC - Bridge Between Mobile and Retail Banking'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'In today\u2019s modern world, more and more clients turn to mobile banking. It is the fastest way for clients to complete transactions, and retrieve information such as their credit scores. We would like clients to have a similar experience in retail banking. How would you bridge the gap between mobile and retail banking? So that clients are more likely to come into a banking center and have a resourceful and efficient experience that mobile banking provides.'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactAccessibleAccordion.AccordionItem,
	                    null,
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemTitle,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '+ TD - Case Challenge'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'Problem Statement:'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Canadians Lack Strong Confidence in Achieving their Financial Goals'
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                '79% of Canadians do not have a strong sense of confidence in their ability to achieve their financial goals'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Only 18% strongly agree that they are knowledgeable about financial matters; and'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Only one in five strongly agree that they\u2019re successful in sticking with their financial strategies.'
	                            )
	                        ),
	                        '* Stats Based off study done by the Financial Planning Standards Council (Nov \'15)'
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'Challenge Question:'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'How can Artificial Intelligence enable people to have confidence in their future?'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'Judging:'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'During your presentation you will be judged on the following criteria, it is up to you to address them all!'
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Innovation \u2013 How unique is your solution?'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Impact \u2013 How much is your idea expected to improve customer confidence?'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Feasibility \u2013 How realistic is the solution for TD?'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Use of Data & Technology, AI'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Alignment with Case Challenge \u2013 Does your solution address the case challenge and problem statement?'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null)
	        )
	    );
	};
	
	exports.default = SponsorChallenges;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sponsorchallenges-js-b9a275988f711b69aec2.js